import React, { useEffect, useState } from "react";
import { Text, Image, TextInput, View, TouchableOpacity } from "react-native";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppImages } from "../../../utility/AppImages";
import { CommonButton } from "../../../common/CommonButton";

import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppScreens } from "../../../screens/Utility/AppScreens";
import Avatar from "../../choose-avatar-components/Avatar";

type UploadFileComponentProps = {
  styles?: any;
  title?: string;
  userId?: string;
  handleUpdates?: any;
  profilePicture?: any;
  onFileSelect?: (fileUrl: string) => void;
  showLoader?: boolean;
  setShowLoader?: (show: boolean) => void;
};

const UploadFileComponent: React.FC<UploadFileComponentProps> = ({
  styles,
  title,
  userId,
  handleUpdates,
  profilePicture,
  onFileSelect,
  showLoader,
  setShowLoader,
}) => {
  const navigation = useNavigation();
  return (
    <>
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_12,
          { color: AppColors.gray_C3C3C3 },
        ]}
      >
        {title}
      </Text>
      <View
        style={[
          styles.uploadView,
          {
            marginTop: title ? 10 : 0,
          },
        ]}
      >
        <View
          style={[
            styles.uploadDetails,
            {
              flexDirection: "row",
              // width: "84%",
              justifyContent: "space-between",
            },
          ]}
        >
          <View
            style={{
              flexDirection: "row",
              gap: 10,
              flex: 1,
              alignItems: "center",
            }}
          >
            <TouchableOpacity>
              {profilePicture != "" ? (
                <Avatar src={profilePicture} variant="smallPlayer" />
              ) : (
                <Image
                  source={AppImages.icDragNDrop}
                  resizeMode="contain"
                  style={{ width: 42, height: 42 }}
                />
              )}
            </TouchableOpacity>
          </View>
          <CommonButton
            title="Change Avatar"
            onTap={() =>
              // navigation.dispatch(
              //   CommonActions.reset({
              //     index: 0,
              //     routes: [{ name: "ChangeAvatar" }],
              //   })
              // )
              navigateToScreen(navigation, AppScreens.ChangeAvatar, {
                  screen: "Setting",
                })
            }
            buttonStyle={styles.btnStyle}
            textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
            disabled={showLoader}
          />
        </View>
      </View>
    </>
  );
};

export default UploadFileComponent;
